import script from "./AppSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSwitch.vue?vue&type=script&setup=true&lang=js"

import "./AppSwitch.vue?vue&type=style&index=0&id=0107a95c&scoped=true&lang=css"

import exportComponent from "/Users/datis/Developer/ad-impact/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0107a95c"]])

export default __exports__